import { IWPImage } from "@/src/types";
import React from "react";

import S from "./WhyMetlab.styled";
import { getImage } from "gatsby-plugin-image";

export interface Props {
  title: string;
  items: {
    image: IWPImage;
    title: string;
    text: string;
  }[];
}

const WhyMetlab: React.FC<Props> = ({ title, items }) => {
  return (
    <div>
      <div className="md:mx-auto md:max-w-7xl pb-24">
        <h3 className="mt-0 text-3xl text-center py-6">{title}</h3>
        <section className="flex lg:flex-row items-stretch lg:justify-between sm:center flex-col md:text-left text-center">
          {items.map((item, idx) => {
            const itemImageData = item.image?.localFile?.childImageSharp
              ?.gatsbyImageData
              ? getImage(item.image.localFile.childImageSharp.gatsbyImageData)
              : null;

            return (
              <div className="info-card bg-white shadow-none transition duration-400 ease-in-out m-4 py-6 px-6 whitespace-no-wrap flex flex-col justify-between rounded-md">
                <div className="w-20 mx-auto md:mx-0">
                  {itemImageData && (
                    <S.ItemImage
                      image={itemImageData}
                      alt={item.image.altText ? item.image.altText : item.title}
                      className="w-20 md:mx-0 mx-auto select-none pointer-events-none"
                    />
                  )}
                </div>
                <div>
                  <h4 className="text-xl">{item.title}</h4>
                  <p
                    className=""
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  ></p>
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default WhyMetlab;
